import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../utils/colors';
import ScrollIndicator from './shared/ScrollIndicator';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const MadonnaChildPage = () => {
  // Use our custom hook to apply random colors to all links
  useRandomLinkColors();
  // Additional effect to ensure all links on this specific page get random colors
  useEffect(() => {
    const pageLinks = document.querySelectorAll('a');
    pageLinks.forEach(link => {
      if (!link.dataset.colorApplied) {
        link.style.color = getRandomColor();
        link.dataset.colorApplied = 'true';
      }
    });
  }, []);
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/pphRw9FSd67prU6JkSqeeM/Madeleine_Morlet_1.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/1gohq5pxqgbdPifnTRu3Hx/Madeleine_Morlet_2.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/wek5obGueb1GcANH7YUafd/Madeleine_Morlet_3.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/drTSDBgXrqtDrLDduKBUak/Madeleine_Morlet_4.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/mQK1YS7tgqUw4goGV8EwZb/Madeleine_Morlet_5.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/3EiNJ7csTwn3vnnPcbYbQT/Madeleine_Morlet_6.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/jAwu9NG5rr6bYAeskoA5nc/Madeleine_Morlet_7.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/333skG8wqSbHAULsHpcaiW/Madeleine_Morlet_8.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/qiP4e6FbipCcFgTJHrRGFH/Madeleine_Morlet_9.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/w5kp6HN7pXfkqqTcsvZCoi/Madeleine_Morlet_10.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ujnPHQWh7o46XC6y7HkLFb/Madeleine_Morlet_11.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/tJsZDjVvnufuXVBRsMbHyL/Madeleine_Morlet_12.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/jsjeTMsj8CqUkN854abi2Y/Madeleine_Morlet_13.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/njHiaFSahhgXjXS9cqG3Uz/Madeleine_Morlet_14.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/ko1SnZdewtM3GaNAm7n2VH/Madeleine_Morlet_15.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/hzSNRiGJ2QH693XQSuiQUe/Madeleine_Morlet_16.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/khdUcN2vHciqLHu49wvJdr/Madeleine_Morlet_17.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/dKoRG3rwrxvWQ44PnjXwjJ/Madeleine_Morlet_18.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/6e4dubFJYe5yoBtFVCdPu2/Madeleine_Morlet_19.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/m1TzRETKqMUauxXyQf8XPH/Madeleine_Morlet_20.jpg'];
  // Create varied spacing and sizing for editorial layout
  const getSpacing = index => {
    const spacings = [8, 14, 10, 16, 12, 18, 9, 15];
    return spacings[index % spacings.length];
  };
  const getImageSize = (index: number) => {
    if (index === 0) return '70vh'; // First image consistent with other pages
    const sizes = ['85vh', '65vh', '75vh', '80vh', '70vh'];
    return sizes[index % sizes.length];
  };
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-260">
      <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-10 bg-[#faf9f7]" data-id="element-261">
        <div className="flex space-x-6" data-id="element-262">
          <div className="text-base font-normal" data-id="element-263">
            <Link to="/" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-264">
              Madeleine Morlet
            </Link>
          </div>
          <div className="text-base font-normal" data-id="element-265">
            <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-266">
              Info
            </Link>
          </div>
        </div>
      </header>
      {/* Desktop Layout */}
      <div className="hidden md:block h-screen overflow-x-auto hide-scrollbar" data-id="element-267">
        <div className="flex min-w-max" data-id="element-268">
          <div className="w-[33vw] pl-16 flex-shrink-0" style={{
          paddingTop: '24vh'
        }} data-id="element-269">
            <div className="text-base max-w-[360px] pr-4" data-id="element-270">
              <div data-id="element-271">
                Madonna & Child (<em data-id="element-272">Badlon Magazine</em>, 2025)
              </div>
              <div className="mt-4 text-sm leading-relaxed" data-id="element-273">
                Talent{' '}
                <a href="https://www.instagram.com/itmilaa" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-274">
                  @itmilaa
                </a>{' '}
                and Baby Blue
                <br data-id="element-275" />
                Casting{' '}
                <a href="https://www.instagram.com/annabelcousins" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-276">
                  @annabelcousins
                </a>
                <br data-id="element-277" />
                Art direction{' '}
                <a href="https://www.instagram.com/mia.theresa" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-278">
                  @mia.theresa
                </a>
                <br data-id="element-279" />
                Lighting{' '}
                <a href="https://www.instagram.com/paulperelka" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-280">
                  @paulperelka
                </a>
                <br data-id="element-281" />
                Digi and Colour Grade Dan Simms
                <br data-id="element-282" />
                Hair{' '}
                <a href="https://www.instagram.com/konstantinos_vrettakos" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-283">
                  @konstantinos_vrettakos
                </a>
                <br data-id="element-284" />
                Makeup{' '}
                <a href="https://www.instagram.com/maritapolitou" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-285">
                  @maritapolitou
                </a>
                <br data-id="element-286" />
                Stylist{' '}
                <a href="https://www.instagram.com/_mayukawasaki_" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-287">
                  @_mayukawasaki_
                </a>
                <br data-id="element-288" />
                Styling Assistants{' '}
                <a href="https://www.instagram.com/yuma_nkhm" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-289">
                  @yuma_nkhm
                </a>{' '}
                <a href="https://www.instagram.com/_motoki__" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-290">
                  @_motoki__
                </a>
                <br data-id="element-291" />
                Studio{' '}
                <a href="https://www.instagram.com/indrastudios" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" onMouseEnter={e => {
                e.currentTarget.style.color = getRandomColor();
              }} onMouseLeave={e => {
                e.currentTarget.style.color = '#333333';
              }} data-id="element-292">
                  @indrastudios
                </a>
                <br data-id="element-293" />
                Thank you Charlotte Brown
              </div>
            </div>
          </div>
          <div className="flex items-start" style={{
          paddingTop: '16vh'
        }} data-id="element-294">
            {images.map((image, index) => <div key={index} className="flex-shrink-0" style={{
            marginRight: index === images.length - 1 ? 0 : `${getSpacing(index)}rem`
          }} data-id="element-295">
                <img src={image} alt={`Madonna & Child - Image ${index + 1}`} className="w-auto object-contain" style={{
              height: getImageSize(index)
            }} data-id="element-296" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="md:hidden pt-20 px-6" data-id="element-297">
        <div className="mb-6" data-id="element-298">
          <div className="text-base mb-4" data-id="element-299">
            Madonna & Child (<em data-id="element-300">Badlon Magazine</em>, 2025)
          </div>
          <div className="text-sm leading-relaxed" data-id="element-301">
            Talent{' '}
            <a href="https://www.instagram.com/itmilaa" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-302">
              @itmilaa
            </a>{' '}
            and Baby Blue
            <br data-id="element-303" />
            Casting{' '}
            <a href="https://www.instagram.com/annabelcousins" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-304">
              @annabelcousins
            </a>
            <br data-id="element-305" />
            Art direction{' '}
            <a href="https://www.instagram.com/mia.theresa" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-306">
              @mia.theresa
            </a>
            <br data-id="element-307" />
            Lighting{' '}
            <a href="https://www.instagram.com/paulperelka" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-308">
              @paulperelka
            </a>
            <br data-id="element-309" />
            Digi and Colour Grade Dan Simms
            <br data-id="element-310" />
            Hair{' '}
            <a href="https://www.instagram.com/konstantinos_vrettakos" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-311">
              @konstantinos_vrettakos
            </a>
            <br data-id="element-312" />
            Makeup{' '}
            <a href="https://www.instagram.com/maritapolitou" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-313">
              @maritapolitou
            </a>
            <br data-id="element-314" />
            Stylist{' '}
            <a href="https://www.instagram.com/_mayukawasaki_" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-315">
              @_mayukawasaki_
            </a>
            <br data-id="element-316" />
            Styling Assistants{' '}
            <a href="https://www.instagram.com/yuma_nkhm" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-317">
              @yuma_nkhm
            </a>{' '}
            <a href="https://www.instagram.com/_motoki__" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-318">
              @_motoki__
            </a>
            <br data-id="element-319" />
            Studio{' '}
            <a href="https://www.instagram.com/indrastudios" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200" data-id="element-320">
              @indrastudios
            </a>
            <br data-id="element-321" />
            Thank you Charlotte Brown
          </div>
        </div>
        <div className="w-full space-y-8" data-id="element-322">
          {images.map((image, index) => <div key={index} className="w-full" data-id="element-323">
              <img src={image} alt={`Madonna & Child - Image ${index + 1}`} className="w-full h-auto object-contain" data-id="element-324" />
            </div>)}
        </div>
      </div>
      <ScrollIndicator data-id="element-325" />
      <style jsx data-id="element-326">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};
export default MadonnaChildPage;